<template>
  <div class="list-banners">
    <navigator :items="items"></navigator>
    <div class="container-fluid">
      <div class="row">
        <div class="col-12">
          <div class="card">
            <div class="container-fluid">
              <div class="row filter-row">
                <div class="col-12">
                  <h5>Filtros</h5>
                </div>
                <div class="col-lg-5">
                  <div class="form-group">
                    <input
                      type="text"
                      v-model="filter.title"
                      placeholder="Título"
                      class="form-control"
                    />
                  </div>
                </div>
                <div class="col-lg-3">
                  <button class="btn btn-primary" v-on:click="filterTable()">
                    Pesquisar
                  </button>
                </div>
              </div>
              <div class="row">
                <div class="col-12">
                  <b-table
                    hover
                    :fields="fields"
                    :items="data"
                    :per-page="0"
                    :current-page="currentPage"
                    @row-clicked="selectItemTable"
                  >
                    <template v-slot:cell(file_url)="data">
                      <div class="d-flex justify-content-center">
                        <img :src="data.value" alt class="image-icon" />
                      </div>
                    </template>
                    <template v-slot:cell(validity_start_date)="data">
                      {{ data.value ? formatDate(data.value) : "-" }}
                      <i
                        v-if="data.value"
                        aria-hidden="true"
                      ></i>
                    </template>
                    <template v-slot:cell(validity_end_date)="data">
                      {{ data.value ? formatDate(data.value) : "-" }}
                      <i
                        v-if="data.value"
                        aria-hidden="true"
                      ></i>
                    </template>
                  </b-table>
                  <div class="no-data" v-if="data.length == 0">
                    <span>Sem dados</span>
                  </div>
                  <b-pagination
                    class="float-right"
                    v-model="currentPage"
                    :total-rows="rows"
                    :per-page="perPage"
                    aria-controls="my-table"
                  ></b-pagination>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "@/api/axios";
import { bus } from "@/main";
import moment from "moment";

export default {
  name: "list-banners",
  data() {
    return {
      items: [
        {
          text: "Avisos Agendados",
          active: true,
        },
        {
          text: "Novo Aviso",
          route: "admin.banner",
        },
      ],
      filter: {
        name: "",
      },
      perPage: 10,
      currentPage: 1,
      rows: 0,
      data: [],
      fields: [
        { key: "file_url", label: "Imagem", class: "image-col" },
        { key: "title", label: "Título" },
        { key: "validity_start_date", label: "Início da Vigência" },
        { key: "validity_end_date", label: "Final da Vigência" },
      ],
    };
  },
  watch: {
    currentPage: {
      handler: function (value) {
        this.providerData();
      },
    },
  },
  mounted() {
    this.getSavedData();
    bus.$emit("changeLoading", true);
    this.providerData();
  },
  methods: {
    filterTable() {
      this.currentPage = 1;
      this.providerData();
    },
    providerData() {
      axios
        .get(`${process.env.VUE_APP_API_HOST}/api/banners?${this.urlBuild()}`)
        .then((response) => {
          this.rows = response.data.total;
          this.data = response.data.data;
          bus.$emit("changeLoading", false);
        });
    },
    getSavedData: function () {
      if (
        localStorage.getItem("filters_list_banners") != null &&
        localStorage.getItem("filters_list_banners") != ""
      ) {
        var data = JSON.parse(localStorage.getItem("filters_list_banners"));
        this.filter = data.filter;
      }
    },
    saveDataOnStorage: function () {
      let filters = {
        filter: this.filter,
      };
      localStorage.setItem("filters_list_banners", JSON.stringify(filters));
    },
    urlBuild: function () {
      this.saveDataOnStorage();
      let url =
        "sort=-id&page[number]=" +
        this.currentPage +
        "&page[size]=" +
        this.perPage +
        (this.filter.title && this.filter.title != "" ? `&filter[title]=${this.filter.title}` : "");
      return url;
    },
    selectItemTable: function (record, index) {
      this.$router.push({ name: "admin.banner", params: { id: record.id } });
    },
     formatDate: function (date) {
      return moment(date).format("DD/MM/YYYY, H:MM:SS ");
    },
  },
};
</script>

<style lang="scss">
@import "@/styles/General.scss";
.list-banners {
  .image-icon {
    margin: 1vw;
    height: 10vh;
  }
  .image-col {
    width: 15%;
  }
}
</style>